import { forwardRef } from 'react';
import type { CustomContentProps } from 'notistack';
import { SnackbarContent, useSnackbar } from 'notistack';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from 'shared/ui/collapsible';
import { Button } from 'shared/ui/button';
import { ChevronDown, X } from 'lucide-react';
interface ReportCompleteProps extends CustomContentProps {
  msgTitle: string;
  msgDescription: string;
}

// eslint-disable-next-line react/display-name
const MessageSnackbar = forwardRef<HTMLDivElement, ReportCompleteProps>(({
  id,
  message,
  msgTitle,
  msgDescription,
  ...other
}, ref) => {
  const {
    closeSnackbar
  } = useSnackbar();

  // const local =
  //   // @ts-ignore
  //   JSON.parse(localStorage.getItem(activeMessageLocalStorageKey)) || {};
  // const expandedDefault =
  //   local.expandedDefault !== undefined ? local.expandedDefault : true;
  // const [expanded, setExpanded] = useState<boolean>(expandedDefault);
  //
  // const handleExpandClick = () => {
  //   setExpanded((prevState) => !prevState);
  //   const localActiveMessage =
  //     // @ts-ignore
  //     JSON.parse(localStorage.getItem(activeMessageLocalStorageKey)) || {};
  //
  //   localStorage.setItem(
  //     activeMessageLocalStorageKey,
  //     JSON.stringify({
  //       ...localActiveMessage,
  //       expandedDefault: !localActiveMessage.expandedDefault,
  //     })
  //   );
  // };

  // useEffect(() => {
  //   const localActiveMessage =
  //     // @ts-ignore
  //     JSON.parse(localStorage.getItem(activeMessageLocalStorageKey)) || {};
  //
  //   if (
  //     localActiveMessage?.id === activeMessage?.id &&
  //     localActiveMessage?.title === activeMessage?.title &&
  //     localActiveMessage?.content === activeMessage?.content
  //   ) {
  //     return;
  //   }
  //
  //   setExpanded(true);
  //   localStorage.setItem(
  //     activeMessageLocalStorageKey,
  //     JSON.stringify({
  //       ...activeMessage,
  //       expandedDefault: true,
  //     })
  //   );
  // }, [activeMessage]);

  const handleDismiss = () => {
    closeSnackbar(id);
  };
  return <SnackbarContent ref={ref} role="alert" {...other}>
        <div className="bg-secondary !w-[350px] rounded-lg border-input-border border">
          <Collapsible className="[&[data-state=closed]>div]:rounded-md">
            <div className="flex items-center justify-between space-x-4 bg-primary rounded-t-md p-2">
              <p className="text-body3 flex-2">{msgTitle}</p>
              <div>
                <CollapsibleTrigger className="[&[data-state=open]>*>*]:rotate-180">
                  <Button variant="none" size="sm" className="w-9 p-0 hover:text-white cursor-pointer">
                    <ChevronDown className="size-5 transition-transform duration-200" />
                  </Button>
                </CollapsibleTrigger>
                <Button variant="none" size="sm" className="w-9 p-0 hover:text-white cursor-pointer" onClick={handleDismiss}>
                  <X className="size-5" />
                </Button>
              </div>
            </div>
            <CollapsibleContent className="px-2 py-3 max-h-32 overflow-auto">
              <div className="text-body3">{msgDescription}</div>
            </CollapsibleContent>
          </Collapsible>
        </div>
      </SnackbarContent>;
});
export default MessageSnackbar;